import { render, staticRenderFns } from "./landingRegister.vue?vue&type=template&id=083d82cb&scoped=true&"
import script from "./landingRegister.vue?vue&type=script&lang=js&"
export * from "./landingRegister.vue?vue&type=script&lang=js&"
import style0 from "./landingRegister.vue?vue&type=style&index=0&id=083d82cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083d82cb",
  null
  
)

export default component.exports